import { FocusTrap } from '../../utils/focus-trap';
import { scrollbarWidth } from './utils/scrollbar-width';
export class USAModal {
    constructor(modal) {
        var _a, _b;
        this.openModalWindow = (e) => this.handleModalOpen(e);
        this.closeModalWindow = (e) => this.handleModalClose(e);
        this.closeOutsideModalWindow = (e) => this.handleModalCloseOutside(e);
        this.closeEscapeModalWindow = (e) => this.handleKeyboardEscape(e);
        this.modalEl = modal.cloneNode(true);
        this.modalId = modal.getAttribute('id') || 'usa-modal';
        this.isForced =
            modal.getAttribute('data-force-action') !== null ? 'true' : 'false';
        this.notModal = `body > *:not(.usa-modal-wrapper):not([aria-hidden])`;
        this.opener = document.querySelector(`[aria-controls="${this.modalId}"]`);
        if (this.opener && this.opener.hasAttribute('aria-controls')) {
            (_a = this.opener) === null || _a === void 0 ? void 0 : _a.removeAttribute('aria-controls');
        }
        if (this.opener && !this.opener.getAttribute('data-async-modal')) {
            this.opener.addEventListener('click', this.openModalWindow, false);
        }
        this.wrapperElement = document.createElement('div');
        this.overlayElement = document.createElement('div');
        this.ariaLabelledBy =
            (modal === null || modal === void 0 ? void 0 : modal.getAttribute('aria-labelledby')) || this.modalId;
        this.ariaDescribedBy =
            (modal === null || modal === void 0 ? void 0 : modal.getAttribute('aria-describedby')) || this.modalId;
        this.modal = modal;
        this.modalHeading =
            document.getElementById(`${this.modalId}-heading`) ||
                null;
        this.modalBody = (_b = document.getElementById(`${this.modalId}-description`)) === null || _b === void 0 ? void 0 : _b.parentElement;
        this.modalFooter =
            modal.getElementsByClassName('usa-modal__footer')[0] ||
                null;
        this.isActive = false;
        const focusableElements = 'a[href],area[href],input:not([disabled]):not([type="hidden"]):not([aria-hidden]),select:not([disabled]):not([aria-hidden]),textarea:not([disabled]):not([aria-hidden]),button:not([disabled]):not([aria-hidden]),iframe,object,embed,[contenteditable],[tabindex]:not([tabindex^="-"])';
        this.focusTrap = new FocusTrap(this.modal, focusableElements);
        this.tempBodyPadding = this.setBodyPadding();
        this.setWrapper();
        this.setOverlay();
        this.setModal();
        modal.remove();
        USAModal._components.set(this.modal, this);
    }
    setWrapper() {
        this.wrapperElement.setAttribute('class', 'usa-modal-wrapper');
        this.wrapperElement.classList.add('is-visible');
        this.wrapperElement.setAttribute('aria-labelledby', this.ariaLabelledBy);
        this.wrapperElement.setAttribute('aria-describedby', this.ariaDescribedBy);
        this.wrapperElement.setAttribute('role', 'dialog');
        this.wrapperElement.setAttribute('id', this.modalId);
    }
    setOverlay() {
        this.overlayElement.setAttribute('class', 'usa-modal-overlay');
        this.overlayElement.setAttribute('aria-controls', this.modalId);
    }
    setCloseButtons() {
        this.footerButtons = Array.from(this.modal.querySelectorAll('[data-close-modal]'));
        this.footerButtons.map((closeButton) => {
            closeButton.addEventListener('click', this.closeModalWindow, false);
        });
    }
    setModal() {
        this.modal.setAttribute('tabIndex', '-1');
        this.modal.removeAttribute('id');
        this.modal.removeAttribute('aria-describedby');
        this.modal.removeAttribute('aria-labelledby');
        this.setCloseButtons();
    }
    setBodyPadding() {
        const scrollBarTempWidth = new scrollbarWidth().getWidth();
        const initialPadding = window
            .getComputedStyle(document.body)
            .getPropertyValue('padding-right');
        const tempPadding = `${parseInt(initialPadding.replace(/px/, ''), 10) +
            parseInt(scrollBarTempWidth.replace(/px/, ''), 10)}px`;
        return tempPadding;
    }
    toggleBodyClass() {
        if (document.body.style.paddingRight === this.tempBodyPadding) {
            document.body.style.removeProperty('padding-right');
        }
        else {
            document.body.style.paddingRight = this.tempBodyPadding;
        }
        const isActive = document.body.classList.contains('usa-js-modal--active');
        document.body.classList.toggle('usa-js-modal--active', !isActive);
    }
    activateModal() {
        this.toggleBodyClass();
        this.isActive = true;
        if (this.isForced == 'false') {
            this.overlayElement.addEventListener('click', this.closeOutsideModalWindow, false);
            this.modal.addEventListener('keydown', this.closeEscapeModalWindow, false);
        }
        document.querySelectorAll(this.notModal).forEach((nonModal) => {
            nonModal.setAttribute('aria-hidden', 'true');
            nonModal.setAttribute('data-modal-hidden', '');
        });
        this.overlayElement.appendChild(this.modal);
        this.wrapperElement.appendChild(this.overlayElement);
        document.body.appendChild(this.wrapperElement);
        this.focusTrap.toggleTrap(true, this.modal);
    }
    deActivateModal() {
        this.toggleBodyClass();
        this.isActive = false;
        if (this.isForced == 'false') {
            this.overlayElement.removeEventListener('click', this.closeOutsideModalWindow);
            this.modal.removeEventListener('keydown', this.closeEscapeModalWindow);
        }
        document.querySelectorAll('[data-modal-hidden]').forEach((nonModal) => {
            nonModal.removeAttribute('aria-hidden');
            nonModal.removeAttribute('data-modal-hidden');
        });
        this.focusTrap.toggleTrap(false, this.modal);
        this.wrapperElement.remove();
    }
    handleModalOpen(event) {
        const mouseEvent = event;
        mouseEvent.preventDefault();
        this.activateModal();
        this.modal.dispatchEvent(new CustomEvent('usa-modal:open', {
            bubbles: true,
            detail: {
                modal: this.modal,
                target: mouseEvent.target,
            },
        }));
    }
    handleModalClose(event) {
        const mouseEvent = event;
        if (mouseEvent.target == mouseEvent.currentTarget) {
            this.deActivateModal();
            this.modal.dispatchEvent(new CustomEvent('usa-modal:close', {
                bubbles: true,
                detail: {
                    modal: this.modal,
                    target: mouseEvent.target,
                },
            }));
        }
    }
    handleModalCloseOutside(event) {
        const mouseEvent = event;
        if (mouseEvent.target == mouseEvent.currentTarget) {
            this.deActivateModal();
            this.modal.dispatchEvent(new CustomEvent('usa-modal:close:outside', {
                bubbles: true,
                detail: {
                    modal: this.modal,
                    target: mouseEvent.target,
                },
            }));
        }
    }
    handleKeyboardEscape(event) {
        const keyboardEvent = event;
        switch (keyboardEvent.key) {
            case 'Escape': {
                if (this.modal) {
                    this.deActivateModal();
                    this.modal.dispatchEvent(new CustomEvent('usa-modal:close:escape', {
                        bubbles: true,
                        detail: {
                            target: keyboardEvent.target,
                        },
                    }));
                }
                break;
            }
        }
    }
    static createIcon() {
        const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        iconSvg.setAttribute('class', 'usa-icon');
        iconSvg.setAttribute('role', 'img');
        iconSvg.setAttribute('aria-hidden', 'true');
        iconSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        iconPath.setAttribute('fill', 'none');
        iconPath.setAttribute('stroke', 'currentColor');
        iconPath.setAttribute('stroke-linecap', 'round');
        iconPath.setAttribute('stroke-width', '2');
        iconPath.setAttribute('d', 'M0 13.0332964L13.0332964 0M13.0332964 13.0332964L0 0');
        iconPath.setAttribute('transform', 'translate(1 1)');
        iconSvg.appendChild(iconPath);
        return iconSvg;
    }
    static createBlankModal(config) {
        const emptyModal = document.createElement('div');
        emptyModal.setAttribute('class', 'usa-modal');
        if (config.modifier) {
            emptyModal.classList.add(config.modifier);
        }
        if (config.forced) {
            emptyModal.setAttribute('data-force-action', '');
        }
        emptyModal.setAttribute('id', config.id);
        emptyModal.setAttribute('aria-labelledby', config.id);
        emptyModal.setAttribute('aria-describedby', config.id);
        const modalContent = document.createElement('div');
        modalContent.setAttribute('class', 'usa-modal__content');
        const modalMain = document.createElement('div');
        modalMain.setAttribute('class', 'usa-modal__main');
        modalMain.setAttribute('id', `${config.id}-main`);
        const modalProse = document.createElement('div');
        modalProse.setAttribute('class', 'usa-prose');
        const modalDescription = document.createElement('p');
        modalDescription.setAttribute('id', `${config.id}-description`);
        const closeButton = document.createElement('button');
        closeButton.setAttribute('class', 'usa-button usa-modal__close');
        closeButton.setAttribute('data-close-modal', '');
        closeButton.setAttribute('aria-label', 'Close this Window');
        closeButton.appendChild(this.createIcon());
        modalProse.appendChild(modalDescription);
        modalMain.appendChild(modalProse);
        modalContent.appendChild(modalMain);
        if (!config.forced) {
            modalContent.appendChild(closeButton);
        }
        emptyModal.appendChild(modalContent);
        document.body.appendChild(emptyModal);
        return emptyModal;
    }
    updateHeading(copy) {
        if (this.modalHeading == null) {
            const modalHeader = document.createElement('h2');
            modalHeader.setAttribute('class', 'usa-modal__heading');
            modalHeader.setAttribute('id', `${this.modalId}-heading`);
            this.modalHeading = modalHeader;
            const modalMain = this.modal.querySelector('.usa-modal__main');
            modalMain === null || modalMain === void 0 ? void 0 : modalMain.prepend(modalHeader);
        }
        if (typeof copy === 'string') {
            this.modalHeading.textContent = copy;
        }
        else if (copy instanceof HTMLHeadingElement) {
            this.modalHeading.replaceChildren(...Array.from(copy.childNodes));
        }
    }
    updateBody(copy) {
        if (typeof copy === 'string') {
            this.modalBody.innerHTML = copy;
        }
        else if (copy instanceof HTMLElement) {
            this.modalBody.replaceChildren(...Array.from(copy.childNodes));
        }
        this.focusTrap.refreshTrap(this.modal);
    }
    updateButtons(config) {
        if (this.modalFooter == null) {
            const footerElement = document.createElement('div');
            footerElement.classList.add('usa-modal__footer');
            const modalMain = this.modal.querySelector('.usa-modal__main');
            modalMain === null || modalMain === void 0 ? void 0 : modalMain.appendChild(footerElement);
            this.modalFooter = footerElement;
        }
        this.modalFooter.innerHTML = '';
        const buttonGroup = document.createElement('ul');
        buttonGroup.classList.add('usa-button-group');
        config.map((item) => {
            const buttonGroupItem = document.createElement('li');
            buttonGroupItem.setAttribute('class', 'usa-button-group__item');
            const buttonElement = document.createElement('button');
            buttonElement.setAttribute('class', `usa-button ${item.style}`);
            buttonElement.innerHTML = item.label;
            if (item.closeModal) {
                buttonElement.setAttribute('data-close-modal', '');
            }
            if (typeof item.cbfunction == 'function') {
                buttonElement.addEventListener('click', () => { var _a; return (_a = item.cbfunction) === null || _a === void 0 ? void 0 : _a.call(item); });
            }
            buttonElement.setAttribute('type', 'button');
            buttonGroupItem.appendChild(buttonElement);
            buttonGroup.appendChild(buttonGroupItem);
            this.modalFooter.appendChild(buttonGroup);
        });
        this.setCloseButtons();
        this.focusTrap.refreshTrap(this.modal);
    }
    updateDialog(config) {
        if (config.title) {
            this.updateHeading(config.title);
        }
        if (config.content) {
            this.updateBody(config.content);
        }
        if (config.footer) {
            this.updateButtons(config.footer);
        }
        this.focusTrap.refreshTrap(this.modal);
    }
    static createConfig(config) {
        const modalTemp = this.createBlankModal(config);
        return (this._components.get(modalTemp) ||
            new this(modalTemp));
    }
    static create(modal) {
        if (!(modal instanceof HTMLElement)) {
            throw 'Element is not an HTMLElement';
        }
        else {
            return (this._components.get(modal) ||
                new this(modal));
        }
    }
    static createAll() {
        const modals = [];
        const dialogs = Array.from(document.getElementsByClassName('usa-modal'));
        dialogs.map((modal) => {
            modals.push(this.create(modal));
        });
        return modals;
    }
    static autoInit() {
        document.addEventListener('DOMContentLoaded', () => {
            this.createAll();
        });
    }
    unregister() {
        this.modal.remove();
        this.overlayElement.remove();
        this.wrapperElement.remove();
        const closeButtons = Array.from(this.modal.querySelectorAll('[data-close-modal]'));
        closeButtons.map((closeButton) => {
            closeButton.removeEventListener('click', this.closeModalWindow);
        });
        this.opener.setAttribute('aria-controls', this.modalId);
        this.opener.insertAdjacentElement('afterend', this.modalEl);
        this.opener.removeEventListener('click', this.openModalWindow);
    }
}
USAModal._components = new Map();
